import React from 'react'
import PropTypes from 'prop-types'
import { View, Text, StyleSheet } from 'react-native'

type ZoomHoverBoxProps = {
  position: ZoomHoverBoxPosition,
  imageSize: ImageSize,
  accentColor: string,
  boxWidth: number,
  boxHeight: number,
}

export type ImageSize = {
  width: number,
  height: number,
}

export type ZoomHoverBoxPosition = {
  top: number,
  left: number,
}

export const ZoomHoverBox = ({position, imageSize, accentColor, boxWidth, boxHeight}: ZoomHoverBoxProps) => {
  const styles = StyleSheet.create({
    box: {
      position: 'absolute',
      top: position.top,
      left: position.left,
      maxWidth: boxWidth,
      height: '100%',
      width: '100%',
      maxHeight: boxHeight,
      backgroundColor: accentColor,
      pointerEvents: 'none',
      opacity: 0.25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })

  return (
    <View style={styles.box}>
    </View>
  )
}

ZoomHoverBox.propTypes = {
  position: PropTypes.object.isRequired,
  imageSize: PropTypes.object.isRequired,
  accentColor: PropTypes.string.isRequired,
}